import isNil from 'lodash-es/isNil';
import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';
import { ErrorResults, IValidationResult } from '../types';

export const setErrorsHanlder =
  <TFieldValues extends FieldValues>(form: UseFormReturn<TFieldValues>) =>
  (errorResults: IValidationResult['result'] | ErrorResults<TFieldValues>) => {
    if (isNil(errorResults)) {
      return;
    }

    if (Array.isArray(errorResults) && errorResults.length > 0) {
      errorResults.forEach((error) => {
        form.setError(error.name as FieldPath<TFieldValues>, { message: error.message });
      });
    } else {
      for (const [key, value] of Object.entries(errorResults)) {
        form.setError(key as FieldPath<TFieldValues>, { message: value });
      }
    }
  };
